import PercorsoDrawerReducer from './PercorsoDrawerReducer'
import {PERCORSODRAWER} from './PercorsoDrawerTypes'

export const changePercorsoDrawer = percorsoDrawer => {
    return {
        type: PERCORSODRAWER,
        load: percorsoDrawer
    }
}
export const selectNewPercorsoDrawer = (percorsoDrawer) => {

    return (dispatch) => {
        dispatch(changePercorsoDrawer(percorsoDrawer))
    }

}